import { useState } from 'react';

type Question = { q: string; a: string };

const questions: Question[] = [
  {
    q: 'Do you mark up token costs?',
    a: 'No. You pay your providers directly with your own credentials. Key Receipt is a flat monthly fee — never a percentage of your spend.',
  },
  {
    q: 'What about subscription plans like Claude Max?',
    a: 'Mark a credential as Subscription with its monthly cost. We allocate that flat fee pro-rata across the inbound tokens routing through it — so a $200/mo Claude Max sub gets split correctly across the clients sharing it.',
  },
  {
    q: 'Will my tools actually work with this?',
    a: 'If the tool lets you set a base URL and an API key, yes. Claude Code, Cursor (custom OpenAI mode), Cline, Aider, Continue, Cody, Roo Code, and direct SDK calls all work without code changes.',
  },
  {
    q: 'Where does my data go?',
    a: 'Request and response bodies are forwarded to the upstream provider and not retained. We store metadata only — timestamp, token count, model, dollar cost, and the client tag.',
  },
  {
    q: 'Can I export to Bonsai / Harvest / Xero / FreshBooks?',
    a: 'Yes. CSV export is shaped for direct import into all four. Agency plan adds scheduled monthly exports.',
  },
  {
    q: 'What happens after the 14-day trial?',
    a: 'Your card is charged the plan you selected. Cancel anytime in one click — no email-the-team nonsense.',
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-24 border-t-2 border-border">
      <div className="container-ledger max-w-3xl">
        <div className="text-[11px] font-mono uppercase tracking-[0.18em] text-spray-magenta mb-4 font-bold">
          // Questions
        </div>
        <h2 className="font-display text-4xl md:text-5xl uppercase leading-[0.95] mb-12">
          Things people ask <br />
          <span className="text-spray-yellow">before signing up.</span>
        </h2>
        <ul className="border-t-2 border-border">
          {questions.map((item) => (
            <QAItem key={item.q} item={item} />
          ))}
        </ul>
      </div>
    </section>
  );
}

function QAItem({ item }: { item: Question }) {
  const [open, setOpen] = useState(false);
  return (
    <li className="border-b-2 border-border">
      <button
        onClick={() => setOpen((current) => !current)}
        className="w-full flex items-center justify-between gap-6 py-5 text-left text-base font-bold uppercase hover:text-spray-yellow transition-colors"
        aria-expanded={open}
      >
        <span>{item.q}</span>
        <span aria-hidden className="font-mono text-spray-yellow shrink-0">
          {open ? '−' : '+'}
        </span>
      </button>
      {open && (
        <p className="pb-6 pr-6 text-muted-foreground leading-relaxed text-sm">{item.a}</p>
      )}
    </li>
  );
}
